import { isAuthAction } from '$lib/localization/locale';
import { version } from '$app/environment';
import { initializeSentryConsole, pageConsoleContext } from '$lib/sentryConsole';

export function init(): void {
	if (!isAuthAction(location.pathname)) {
		initializeSentryConsole(pageConsoleContext(version), 'page');
	}
}
